import { LIVE_AGENT_CONNECTED_MESSAGE } from '../constants';

/**
 * Promotes the most recent "connecting" system message in IDB to "connected".
 *
 * PROMOTE ONLY, so it is idempotent and safe for both callers (the escalation flow and the
 * engine at the moment of connection). See .claude/context/live-agent.md
 *
 * @param {Object} opts
 * @param {() => Promise<Array>} opts.getAll - IDB getAll for messages store
 * @param {(msg: Object) => Promise<void>} opts.update - IDB update for messages store
 * @param {() => Promise<Array>} opts.reload - Reloads IDB messages into React state
 * @returns {Promise<void>}
 */
export const updateConnectingToConnected = async ({ getAll, update, reload }) => {
  const allMessages = await getAll();
  // Optional-chained: LIVE_AGENT_ERROR_MESSAGE is a system message with NO variant.
  const connectingMsg = [...allMessages].reverse().find(
    (msg) => msg?.type?.toLowerCase() === 'system' && msg?.variant?.toLowerCase() === 'connecting'
  );
  if (!connectingMsg) return;
  const updated = {
    ...connectingMsg,
    variant: LIVE_AGENT_CONNECTED_MESSAGE.variant,
    content: LIVE_AGENT_CONNECTED_MESSAGE.content,
    dividerText: LIVE_AGENT_CONNECTED_MESSAGE.dividerText,
    timestamp: Date.now(),
    // reconcileMessages reuses the PREVIOUS object when `updatedAt` is unchanged, so without
    // this the promotion lands in IDB and never reaches the UI. See .claude/context/live-agent.md
    updatedAt: Date.now(),
  };
  await update(updated);
  await reload();
};
